import { render, staticRenderFns } from "./UserOrderDetail.vue?vue&type=template&id=4ff053f4&scoped=true&"
import script from "./UserOrderDetail.vue?vue&type=script&lang=ts&"
export * from "./UserOrderDetail.vue?vue&type=script&lang=ts&"
import style0 from "./UserOrderDetail.vue?vue&type=style&index=0&id=4ff053f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff053f4",
  null
  
)

export default component.exports